export default __webpack_public_path__ + "static/floor1-room-d5034fa82aa7644d3e8ad5c367563368.jpg";